import { CloseOutlined } from '@mui/icons-material'
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Icon,
    IconButton,
    Typography,
} from '@mui/material'
import TextInput from '../../Common/TextInput'
import { ReactElement, useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'

interface ListType {
    id: string
    key: string
    value: string
}

interface KeyValueFieldPropsType {
    list: any
    onSave: any
    onClose: any
}

const KeyValueField = (props: KeyValueFieldPropsType): ReactElement => {
    const { t } = useTranslation()
    const { list, onSave, onClose } = props

    const uniqueId = uuidv4()

    const [values, setValues] = useState<ListType[]>([
        { id: uniqueId, key: '', value: '' },
        { id: uniqueId + uniqueId, key: '', value: '' },
    ])

    useEffect(() => {
        try {
            let gettenList = JSON.parse(list)
            gettenList = gettenList.map((i: ListType, index: number) => {
                return { ...i, id: uniqueId + index }
            })
            if (gettenList?.length) {
                setValues(gettenList)
            } else {
                setValues([
                    { id: uniqueId, key: '', value: '' },
                    { id: uniqueId + uniqueId, key: '', value: '' },
                ])
            }
        } catch (e) {
            setValues([
                { id: uniqueId, key: '', value: '' },
                { id: uniqueId + uniqueId, key: '', value: '' },
            ])
            console.log(e)
        }
    }, [list])

    const deleteRowById = (id: string) => {
        const newUniqueId = uuidv4()
        setValues((prev) => {
            let updatedPrev = prev.filter((i) => i.id !== id)
            if (!updatedPrev?.length) {
                updatedPrev = [{ id: newUniqueId, key: '', value: '' }]
            }
            return updatedPrev
        })
    }

    const addNewRow = () => {
        const newUniqueId = uuidv4()
        setValues((prev: ListType[]) => {
            return [...prev, { id: newUniqueId, key: '', value: '' }]
        })
    }

    const onChangeKey = (id: string, key: string) => {
        setValues((prev: ListType[]) => {
            return prev.map((i) => {
                if (i.id === id) {
                    return { ...i, key }
                } else {
                    return { ...i }
                }
            })
        })
    }

    const onChangeValue = (id: string, value: string) => {
        setValues((prev: ListType[]) => {
            return prev.map((i) => {
                if (i.id === id) {
                    return { ...i, value }
                } else {
                    return { ...i }
                }
            })
        })
    }

    const onSaveKeyValues = () => {
        const updatedValues = values.map(({ id, ...rest }) => rest)
        onSave(updatedValues)
    }

    return (
        <Box>
            <Dialog
                open={true}
                scroll="paper"
                PaperProps={{
                    sx: {
                        width: '550px',
                    },
                }}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{ padding: '10px 30px' }}
                // onClose={() => onClose()}
            >
                <Box>
                    <DialogTitle sx={{ padding: '0px' }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            padding="15px"
                            paddingLeft="20px"
                        >
                            <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                sx={{ paddingTop: '10px' }}
                            >
                                {t('defaultValues')}
                            </Typography>
                            <Icon
                                onClick={() => onClose()}
                                sx={{ marginLeft: 'auto' }}
                                fontSize="small"
                                id="key-value-close-icon"
                                aria-label={t('close')}
                                title={t('close')}
                            >
                                <CloseOutlined
                                    sx={{
                                        color: '#000',
                                        marginTop: '-2px',
                                    }}
                                />
                            </Icon>
                        </Box>
                    </DialogTitle>
                    <DialogContent
                        sx={{
                            height: 'auto',
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '20px',
                                    paddingBottom: '10px',
                                }}
                            >
                                <Box sx={{ width: 'calc(50% - 22px)' }}>
                                    <Typography variant="h5">
                                        {t('key')}
                                    </Typography>
                                </Box>
                                <Box sx={{ width: 'calc(50% - 22px)' }}>
                                    <Typography variant="h5">
                                        {t('valuekey')}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                {values?.map((item, index) => (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            marginBottom: '10px',
                                        }}
                                        key={item.id}
                                    >
                                        <Box sx={{ width: 'calc(50% - 22px)' }}>
                                            <TextInput
                                                label=""
                                                id={'key-' + index}
                                                value={item.key}
                                                onChange={(
                                                    id: string,
                                                    val: string,
                                                ) => onChangeKey(item.id, val)}
                                                type="text"
                                            />
                                        </Box>
                                        <Box
                                            sx={{ width: 'calc(50% - 22px)' }}
                                            marginLeft="15px"
                                        >
                                            <TextInput
                                                label=""
                                                id={'value-' + index}
                                                value={item.value}
                                                onChange={(
                                                    id: string,
                                                    val: string,
                                                ) =>
                                                    onChangeValue(item.id, val)
                                                }
                                                type="text"
                                            />
                                        </Box>
                                        <Box marginLeft="12px">
                                            <IconButton
                                                onClick={() =>
                                                    deleteRowById(item.id)
                                                }
                                                sx={{
                                                    padding: '0px',
                                                    marginLeft: 'auto',
                                                }}
                                                id="key-value-delete-button"
                                                aria-label={t('delete')}
                                                title={t('delete')}
                                            >
                                                <CloseOutlined
                                                    sx={{
                                                        color: '#00000080',
                                                    }}
                                                />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                ))}
                                <Box>
                                    <Button
                                        variant="contained"
                                        onClick={() => addNewRow()}
                                        id="key-value-add-button"
                                        aria-label={t('addNew')}
                                        title={t('addNew')}
                                    >
                                        {t('addNew')}
                                    </Button>
                                </Box>
                            </Box>
                        </Box>
                    </DialogContent>
                    <DialogActions
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            padding: '15px 0px',
                            paddingRight: '22px',
                        }}
                    >
                        <Button
                            onClick={() => onClose()}
                            sx={{
                                fontSize: '12px',
                                padding: '7px 20px',
                                marginRight: '15px',
                            }}
                            variant="outlined"
                            id="key-value-cancel-button"
                            aria-label={t('cancel')}
                            title={t('cancel')}
                        >
                            {t('cancel')}
                        </Button>
                        <Button
                            onClick={() => onSaveKeyValues()}
                            sx={{
                                fontSize: '12px',
                                padding: '7px 20px',
                                marginRight: '15px',
                            }}
                            variant="contained"
                            id="key-value-save-button"
                            aria-label={t('save')}
                            title={t('save')}
                        >
                            {t('save')}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </Box>
    )
}

export default KeyValueField
